<template>
    <div class="container" :style="containerStyle">
        <!--<img class="sologan" :src="sologan"/>-->
        <div class="login-box-warp">
            <login-box></login-box>
        </div>
        <!--<div class="common-header common-footer">-->
        <!--<span>Copyright © 2017 NanFang All Rights Reserved</span>-->
        <!--</div>-->
    </div>

</template>

<script>
    import LoginBox from '@/components/widgets/LoginBox.vue';
    import soLogan from '@/assets/img/slogan.png';

    export default {
        name: 'loginIndex',
        components: {LoginBox},
        data () {
            return {
                sologan: soLogan
            };
        },
        computed: {
            containerStyle () {
                return {
                    background: `url(${window.__APP__CONFIG.signin_pic}) center center / cover no-repeat fixed`
                };
            }
        },
        mounted () {
        },
        methods: {}
    };
</script>

<style lang="less" scoped>
    @import '../../../assets/less/var.less';

    .container {
        min-width: 1200px;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        position: relative;
        min-height: 640px;
        background-color: #fff;
        //border: 1px @borderColor solid;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        .login-box-warp {
            width: 380px;
            box-sizing: border-box;
            min-height: 460px;
            height: auto;
            background-color: #FFF;
            position: absolute;
            top: 50%;
            margin-top: -230px;
            right: 178px;
            border-radius: 5px;

        }

        > .sologan {
            position: absolute;
            top: 347px;
            left: 200px;
            width: 494px;
            height: 111px;
        }
    }


    .common-footer {
        line-height: 60px;
        color: #333333;
        font-size: 12px;
        top: 640px;
        text-align: center;
        position: absolute;
        left: 0;
        width: 1400px;
        height: 60px;
        background-color: #FFF;

        > a {
            color: #333333;
            text-decoration: none;
        }
    }

</style>
